package com.cs.ejobin.ui.picker

import androidx.compose.runtime.Composable

data class PickedImage(
    val bytes: ByteArray,
    val contentType: String,
    val fileExt: String
)

@Composable
expect fun rememberImagePicker(
    onPicked: (PickedImage) -> Unit
): () -> Unit